import { createAndDownloadExcel, generateExcelFilename } from './excelExportUtils';

/**
 * Telemetri geçmiş verilerini Excel formatında indirir
 *
 * @param {Array} rows - DataGrid satırları
 * @param {Array} columns - DataGrid kolonları
 * @param {Object} objectData - Object bilgileri
 * @param {Object} enumData - Enum bilgileri
 * @param {string} nodeId - Node ID
 */
export const exportTelemetryHistory = (rows, columns, objectData, enumData, nodeId) => {
  // Enum değerlerini çözümlemek için value transformer
  const valueTransformer = (value, column, row) => {
    // Enum değerlerini çözümle
    if (value !== undefined && value !== null && column.field !== 'date' && column.field !== 'id') {
      const objectItem = objectData.find(
        (objData) => objData.code === parseInt(column.field)
      );

      if (objectItem && objectItem.type === 1) {
        const enumValue = parseInt(value);
        const enumItem = enumData.find(
          (item) => item.enumVal === enumValue
        );
        if (enumItem) {
          return enumItem.name1;
        }
      }
    }
    return value;
  };

  const fileName = generateExcelFilename('Telemetri_Gecmisi', nodeId || 'Node');

  return createAndDownloadExcel(
    rows,
    columns,
    'Telemetri Geçmişi',
    fileName,
    {
      valueTransformer,
      maxColumnWidth: 50
    }
  );
};
